module.exports = __webpack_public_path__ + "img/image-app-materialhandling.79224fdd.jpg";